const M19LABEL = 'M19';
const isM19Kit = (kitId) => {
    return kitId.startsWith(M19LABEL); 
}

module.exports = {
    isM19Kit
};